/**
 * How many named timed mocks we ship in the product UI.
 * Single source of truth for which `session-N` topics are L1 mock sittings (CFA-63):
 * src/constants/mockSitting.js and netlify/functions/_product.js derive from this value.
 * Keep this module import-free: src/data/topics.js imports it (via mockSitting.js).
 */
export const MOCK_FORM_COUNT = 8;

/** Default mock form when no form id is specified (legacy free-session routing). */
export const FREE_MOCK_FORM = 1;

export const MOCK_FORMS = Array.from({ length: MOCK_FORM_COUNT }, (_, i) => {
  const id = i + 1;
  return {
    id,
    slug: `session-${id}`,
    label: `Mock ${id}`,
    shortLabel: `Session ${id}`,
    href: `/quiz/session-${id}`,
    free: id === FREE_MOCK_FORM,
    blurb:
      id === FREE_MOCK_FORM
        ? 'Always free · score only · full 90-question timed mock · official 2026 topic weights · on-screen BA II Plus'
        : '90 questions · 135 minutes · official 2026 topic weights · distinct item set from the other mocks',
  };
});

export function parseMockFormId(slug = '') {
  const s = String(slug || '').toLowerCase();
  if (s === 'session' || s === 'all' || s === 'mock') return null;
  const m = /^session-(\d+)$/.exec(s);
  if (!m || Number(m[1]) < 1 || Number(m[1]) > MOCK_FORM_COUNT) return null;
  return Number(m[1]);
}

export function isMockSessionSlug(slug = '') {
  const s = String(slug || '').toLowerCase();
  return s === 'session' || s === 'all' || s === 'mock' || Boolean(parseMockFormId(s));
}

export function mockFormById(id) {
  return MOCK_FORMS.find((f) => f.id === Number(id)) || null;
}

export function mockFormHref(id) {
  return mockFormById(id)?.href || '/quiz/session-1';
}

export function canAccessMockForm(formId, { paid = false, isAdmin = false, trialExhausted = false } = {}) {
  if (isAdmin || paid) return true;
  // CFA-7: Mock 1 stays free even after freeUsed / trialExhausted chrome.
  void trialExhausted;
  return Number(formId) === FREE_MOCK_FORM;
}
